// Obfuscated Analytics Configuration
// This file contains encoded analytics IDs to hide them from plain text view

// Simple obfuscation utility
const obf = {
  // ROT13-like encoder for basic obfuscation
  encode: (str) => {
    return btoa(str).split('').reverse().join('');
  },
  
  decode: (str) => {
    try {
      return atob(str.split('').reverse().join(''));
    } catch (e) {
      return str;
    }
  },

  // Character shift obfuscation
  shift: (str, shift = 3) => {
    return str.split('').map(char => {
      const code = char.charCodeAt(0);
      if (code >= 65 && code <= 90) { // A-Z
        return String.fromCharCode(((code - 65 + shift) % 26) + 65);
      } else if (code >= 97 && code <= 122) { // a-z
        return String.fromCharCode(((code - 97 + shift) % 26) + 97);
      } else if (code >= 48 && code <= 57) { // 0-9
        return String.fromCharCode(((code - 48 + shift) % 10) + 48);
      }
      return char;
    }).join('');
  },

  unshift: (str, shift = 3) => {
    return obf.shift(str, -shift);
  }
};

// Obfuscated configuration object
export const analyticsConfig = {
  // GTM configuration (keeping this)
  primary: {
    id: obf.encode('GTM-MXLLMZHF'), // GTM ID obfuscated  
    type: 'gtm'
  },

  secondary: {
    token: obf.shift('999432cd62f34c74b4b91736ba10565d', 5), // Cloudflare token shifted
    type: 'cf'
  },

  // Google Search Console verification (obfuscated)
  verification: {
    content: obf.encode('vQxifAD7cmBMVUyGDesZY-tMCwZRmOKaO4ciyUfckAY'), // GSC verification obfuscated
    type: 'gsc'
  },

  // Decoding methods
  decode: obf.decode,
  unshift: obf.unshift,

  // Dynamic configuration loader
  getConfig: () => {
    return {
      // Removed GA4 configuration
      gtmId: obf.decode(analyticsConfig.primary.id),
      cfToken: obf.unshift(analyticsConfig.secondary.token, 5),
      gscVerification: obf.decode(analyticsConfig.verification.content),
      
      // Additional obfuscated endpoints (removed GA endpoints)
      endpoints: {
        gtm: ['googletagmanager.com', 'gtm.js'].join('/'),
        cf: ['static.cloudflareinsights.com', 'beacon.min.js'].join('/')
      }
    };
  }
};

// Dynamic string builder to avoid hardcoded URLs
export const buildUrls = (config) => {
  const base = 'https://www.';
  const cfBase = 'https://';
  
  return {
    // Removed GA4 URL
    gtm: `${base}${config.endpoints.gtm}?id=${config.gtmId}`,
    cf: `${cfBase}${config.endpoints.cf}/vcd15cbe7772f49c399c6a5babf22c1241717689176015`,
    gtmNoscript: `${base}googletagmanager.com/ns.html?id=${config.gtmId}`
  };
};

export default analyticsConfig;